import { apiRequest } from './client';
import type { AgendaItemOut, AgendaItemUpdate, AgendaReorderRequest } from './types';

export async function updateAgendaItem(id: number, payload: AgendaItemUpdate): Promise<AgendaItemOut> {
  return apiRequest<AgendaItemOut>(`/agenda/${id}`, { method: 'PATCH', body: payload });
}

export async function deleteAgendaItem(id: number): Promise<void> {
  await apiRequest(`/agenda/${id}`, { method: 'DELETE' });
}

export async function reorderAgendaItem(id: number, payload: AgendaReorderRequest): Promise<AgendaItemOut> {
  return apiRequest<AgendaItemOut>(`/agenda/${id}/reorder`, { method: 'POST', body: payload });
}
